import { createRoot } from "react-dom/client";
import "./styles.css";
import "react-photo-view/dist/react-photo-view.css";
import { App } from "@/app";

createRoot(document.getElementById("root")!).render(<App />);
